<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5002 12.2934L17.2939 7.49974L18.001 8.20684L13.2073 13.0005L18.0009 17.7941L17.2938 18.5012L12.5002 13.7076L7.7066 18.5012L6.99949 17.7941L11.7931 13.0005L6.99945 8.20684L7.70656 7.49974L12.5002 12.2934Z"
      fill="currentColor"
    />
  </svg>
</template>

<style scoped lang="postcss"></style>
